import React, { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { getMarriottBonvoyAuthorizeURI } from '../../api/fetch/marriott-authorize';
import { Loader } from '../../components/ui/Loader';
import { useAppSignInRedirect } from '../../hooks/useAppRedirect';
import { useAuthContext } from '../../utils/auth/AuthProvider';
import { IDENTITY_WIDGET_BASEPATH, IDENTITY_WIDGET_PATHS } from '../../utils/constants';
import { getPersistedParameters } from '../../utils/persistParameterContext';
import { getOrigin } from '../../utils/url';

export default function MarriottBonvoyAuthorizePage() {
  const params = getPersistedParameters();
  const { acquireToken } = useAuthContext();
  const redirectToAppSignIn = useAppSignInRedirect();

  useEffect(() => {
    async function verifyTokenAndRedirect() {
      try {
        const token = await acquireToken();

        if (token) {
          const state = (params?.state ?? uuidv4()) as string;
          window.location.href = getMarriottBonvoyAuthorizeURI(
            `${getOrigin().replace('www.', '')}${IDENTITY_WIDGET_BASEPATH}${
              IDENTITY_WIDGET_PATHS.MarriottBonvoyPartnerLink
            }`,
            state,
          );
        } else {
          redirectToAppSignIn();
        }
      } catch (error) {
        console.error('[Auth Redirect] An error occurred while attempting to redirect you to sign in.');
      }
    }

    verifyTokenAndRedirect();
  }, [acquireToken, params?.state, redirectToAppSignIn]);

  return (
    <div data-testid='route-/external/authorize/marriott'>
      <Loader />
    </div>
  );
}
